export default __webpack_public_path__ + "static/media/2315.a91285eb.png";